export enum MicrofrontendPrefix {
    mainApp = 'mis-frontend',
    protocolApp = 'records-front',
    appointmentApp = 'appointment-front',
    protocolConstructorApp = 'protocol-constructor-front',
}
